<template>
  <div>
    <el-container class='container'>
      <el-header class='header'>
        <div class="header__logo" v-if="market == 1">贝贝家</div>
        <div class="header__logo" v-if="market == 2">电商 </div>
        <div class="header__logo" v-if="market == 3">任务墙</div>
        <el-menu
          class="header__menu el-menu-demo"
          mode="horizontal"
          background-color="#fff"
          text-color="#2b2b2b"
          active-text-color="#08f"
          @select="handleSelect"
          router>
          <el-menu-item index="/adList" v-if="market != 1" @click="go(1, '/adList')">贝贝家</el-menu-item>
          <el-menu-item index="/shopGoodsList" v-if="market != 2" @click="go(2, '/shopGoodsList')" >电商</el-menu-item>
          <el-menu-item index="/taskList" v-if="market != 3" @click="go(3, '/taskList')" >任务墙</el-menu-item>
          <el-menu-item index="/moduleList">模块</el-menu-item>
          <!--
          <el-menu-item index="/publicAccountList">公众号</el-menu-item>
          <el-menu-item index="/functionList">功能</el-menu-item>
          -->
          <el-menu-item index="" class="header__logout" @click="logout">退出</el-menu-item>
        </el-menu>
      </el-header>
      <el-container>
        <el-aside width='200px' class='aside'>
          <el-menu :default-active="$route.path"
                   class="el-menu-vertical-demo"
                   @open="handleOpen"
                   @close="handleClose"
                   background-color="#323232"
                   text-color="#fff"
                   active-text-color="#08f"
                   router>
            <el-submenu
              v-for="(item, index) in $router.options.routes"
              :index="index + ''" :key="index" v-show="(!item.hidden && (item.type.indexOf($store.state.routeType) > -1) && (item.market > -1 ? (item.market == market) : true)) && hasRole(item)">
              <template slot="title">
                <span>{{item.title}}</span>
              </template>
              <el-menu-item
                v-for="(child, childInx) in item.children"
                :index="child.path"
                v-if="!child.hidden && (child.market > -1 ? (child.market != market) : true) && hasRole(child)"
                :key="childInx"
                @select="handleSubMenu">{{child.meta.name}}</el-menu-item>
            </el-submenu>
          </el-menu>

        </el-aside>
        <el-main class='content'>
          <router-view v-on:functionChange="functionChange"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<style lang="scss">
  @import "../style/color";
  @import "../style/global";
  .header{
    display: flex;
    padding: 0;
    &__logo{
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $blue;
      font-weight: 700;
      font-size: 28px;
    }
    &__menu{
      display: flex;
      flex: 1;
      border-bottom: none;
    }
    &__logout{
      margin-left: auto;
    }
  }
  .container{
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
  }
  .aside{
    background: #2b2b2b;
    overflow: hidden;
    .el-menu-item,
    .el-submenu,
    .el-menu-item{
      width: 200px;
      overflow: hidden;
    }
  }
  .content{
    border-bottom: none;
    padding: 20px 20px 0;
    background: #ebebeb;
  }
  article{
    padding: 20px;
    background: #fff;
    min-height: calc(100vh - 60px - 20px);
    box-sizing: border-box;
  }

  .el-submenu__title{
    i{
      color: #fff;
    }
  }

  .el-table {
    border-top: 1px solid #ebeef5;
    thead{
      color: #2b2b2b;
    }
    th{
      font-weight: normal;
    }
  }
</style>
<script>
import util from '../script/util'
import {logout} from '../api/api'
export default {
  data () {
    return {
      market: 1
    }
  },
  components: {
  },
  computed: {
    // 当前登录用户的角色（从 store 拿，admin/editor/finance/viewer）
    userRoles () {
      console.log('userRole111')
      try {
        // 从 localStorage 拿角色数组
        return JSON.parse(localStorage.getItem('roles')) || []
      } catch (e) {
        return []
      }
    }
  },
  methods: {
    handleSelect () {},
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    handleSubMenu (key, keyPath) {
      console.log(key, keyPath)
    },
    // 路由改变
    routeChange () {
      this.$store.commit('changeRouteType', this.$route.meta.type)
    },
    logout () {
      let params = {}
      logout(params).then((res) => {
        window.localStorage.removeItem('name')
        this.$router.push('/login')
      })
    },
    functionChange (data) {
      this.market = data
      console.log(this.market)
      console.log(util.getCookie('market'))
    },
    // 页面刷新
    checkFlush () {
      let market = window.localStorage.getItem('market')
      let routeType = window.localStorage.getItem('routeType')
      console.log('market', market)
      console.log('routeType', routeType)
      if (market !== undefined && market !== null) {
        this.$store.commit('changeMarket', market)
      }
      if (routeType !== undefined && routeType !== null) {
        this.$store.commit('changeRouteType', routeType)
      }
    },
    go (market, url) {
      this.market = market
      util.setCookie('market', market)
      this.$router.push(url)
    },
    // 适配多角色：用户有多个角色，只要命中一个就显示
    hasRole (menuItem) {
      // 没配置角色权限 → 所有人可见
      if (!menuItem.meta || !menuItem.meta.role || !Array.isArray(menuItem.meta.role)) {
        return true
      }

      // this.userRoles 是当前用户角色数组：['admin','finance']
      const userRoles = this.userRoles
      const menuAllowRoles = menuItem.meta.role

      // 只要有一个角色匹配，就返回true
      return userRoles.some(role => menuAllowRoles.includes(role))
    },
    getMarket () {
      // 从缓存中获取
      if (util.getCookie('market')) {
        return parseInt(util.getCookie('market'))
      }

      // 循环父路由
      for (let item of this.$router.options.routes) {
        // 没有 children 就跳过
        if (!('children' in item)) continue;

        for (let child of item.children) {
          if (child.path === this.$route.path) {
            if ('market' in item) {
              return item.market
            }
          }
        }
      }

      return 0
    } 

  },
  watch: {
    '$route': 'routeChange'
  },
  mounted () {
    //console.log('route', this.$route)
    //console.log('router', this.$router)
    //console.log('store', this.$store)

    this.routeChange()
    this.market = this.getMarket()
  }
}
</script>



// WEBPACK FOOTER //
// src/page/home.vue